<template>
  <div class="step-indicator" :style="{ width: width }" :class="{ 'signup-design': signupDesign }">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step"
      :class="{ current: current == step.step, valid: step.visited && step.valid, 'first-step': index == 0 }"
    >
      <div v-if="index != 0" class="step-line before"></div>
      <div
        v-if="!signupDesign"
        class="icon-wrapper"
        @click="goToStep(step)"
        :tooltip="signupDesign ? '' : tooltipText"
        @mouseover="setTooltipText(step.title)"
        :tooltip-placement="index == 0 ? 'bottom-right' : index == steps.length - 1 ? 'bottom-left' : 'bottom'"
      >
        <div>
          <span v-show="!showCheckmark(step)">
            <i class="fa-light fa-circle"></i>
          </span>
          <span v-show="showCheckmark(step)">
            <i class="fa-light fa-circle-check"></i>
          </span>
        </div>
      </div>
      <div v-else @click="goToStep(step)" class="signup-design-wrapper" :class="{ done: showCheckmark(step) }">
        <h4 class="title">{{ step.title }}</h4>
        <span class="step-number" v-show="!showCheckmark(step)">
          <i class="fa-light" :class="'fa-circle-' + (index + 1)"></i>
        </span>
        <span class="step-number signup-check" v-show="showCheckmark(step)">
          <!-- <i class="fa-light fa-circle-check"></i> -->
          <img src="@/assets/svg/circle-check.svg" alt="Circle check" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true
    },
    current: Number,
    disabled: Boolean,
    width: {
      type: String,
      default: "100%"
    },
    signupDesign: Boolean
  },
  data() {
    return {
      tooltipText: null
    };
  },
  methods: {
    showCheckmark(step) {
      return step.visited && step.valid;
    },
    goToStep(step) {
      if (step.step == this.current || step.disabled == true || this.disabled == true) {
        return;
      }
      if (!step.allowed) {
        this.setTooltipText(step.deniedAccessMsg);
        return;
      }
      this.$emit("click-step", step.step);
    },
    setTooltipText(text) {
      this.tooltipText = text;
    },
    setTooltipPlacement(index) {
      console.log(index);
      if (index == 0) return "bottom-right";
      else if (index == this.steps.length - 1) return "bottom-left";
      else return "bottom";
    }
  },
  watch: {
    current: {
      handler: function() {
        this.steps.find((s) => s.step == this.current).visited = true;
      }
    }
  }
};
</script>

<style lang="less">
:root {
  --inactive-size: 1px;
  --active-size: 1px;
}
.step-indicator {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  .step:not(.first-step) {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    gap: 2px;
    flex-direction: row;

    .line-wrapper {
      display: flex;
      flex-direction: row;
    }
    .step-line {
      flex-grow: 1;
      background-color: var(--charcoal-20);
      height: var(--inactive-size);
      border-radius: 4px;
      margin-left: 2px;
    }
  }

  .step {
    .icon-wrapper {
      color: var(--charcoal-20);
    }

    &.current {
      .step-line {
        height: var(--active-size);
        background-color: var(--orange-web);
      }
      .icon-wrapper {
        color: var(--orange-web);
      }
    }
    &.valid {
      .step-line {
        height: var(--inactive-size);
        background-color: var(--orange-web-40);
      }
      .icon-wrapper {
        color: var(--orange-web-40);
      }
    }

    &.current.valid {
      .step-line {
        height: var(--inactive-size);
        background-color: var(--orange-web-40);
      }
      .icon-wrapper {
        color: var(--orange-web);
      }
    }
    &:not(.current).valid > .icon-wrapper:hover {
      color: var(--orange-web);
    }
    &:not(.current, .valid) > .icon-wrapper:hover {
      color: var(--charcoal-50);
    }
  }
  &.signup-design {
    .step-line {
      opacity: 0;
    }
  }
  .signup-design-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    h4.title {
      font-size: 12px !important;
    }

    .step-number {
      opacity: 0.4;

      img {
        width: 14px;
      }
    }

    &.done {
      .step-number {
        opacity: 1;
      }
    }
  }

  .current {
    .signup-design-wrapper {
      .step-number {
        opacity: 1;
        color: var(--orange-web);
      }
    }
  }
}

.first-enter-to .last-enter-to {
  position: absolute;
  opacity: 1;
  transform: translateX(0);
}
.first-enter,
.first-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(-100px);
}

.last-enter,
.last-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(100px);
}
.first-enter-active,
.first-leave-active {
  transition: all 0.2s ease;
}
.last-leave-active,
.last-enter-active {
  transition: all 0.2s ease;
  // transition-delay: 0.1s;
}

.mid-next-enter {
  position: absolute;
  opacity: 0;
  transform: translateX(100px);
}
.mid-next-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(-100px);
}
.mid-next-leave-active,
.mid-next-enter-active {
  transition: all 0.2s ease;
  // transition-delay: 0.1s;
}

.mid-previous-enter {
  position: absolute;
  opacity: 0;
  transform: translateX(-100px);
}
.mid-previous-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(100px);
}
.mid-previous-leave-active,
.mid-previous-enter-active {
  transition: all 0.2s ease;
  // transition-delay: 0.1s;
}
</style>
